import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { I18nModule } from '@spartacus/core';
import { GenericLinkModule, OutletRefModule } from '@spartacus/storefront';
import { AccordionModule } from '../../accordion/accordion.module';
import { DynamicFormsModule } from '../../dynamic-forms/dynamic-forms.module';
import { CustomerServiceSectionModule } from '../customer-service-section/customer-service-section.module';
import { CustomerServiceContentComponent } from './customer-service-content.component';

@NgModule({
 // declarations: [CustomerServiceContentComponent],
  imports: [
    CommonModule,
    OutletRefModule,
    CustomerServiceSectionModule,
    AccordionModule,
    DynamicFormsModule,
    GenericLinkModule,
    I18nModule,
    NgbDropdownModule,
    MatListModule,
    MatIconModule,
    RouterModule,
  ],
  //exports: [CustomerServiceContentComponent],
})
export class CustomerServiceContentModule {}
